import { Action } from 'redux';

import { SetSensitiveLabel } from '../../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';

export interface SetSensitiveLabelAction extends Action {
    item: IContentInfo<'database'> | IContentInfo<'table'> | IContentInfo<'datasource'>
    | IContentInfo<'virtualConnection'> | IContentInfo<'virtualConnectionTable'> | IContentInfo<'view'>;
}

export function setSensitiveLabelAction(item: SetSensitiveLabelAction['item']): SetSensitiveLabelAction {
    return {
        type: SetSensitiveLabel,
        item
    };
}
